import { toAbsoluteUrl } from "../../../../_metronic/helpers";
import { defaultProfileImage } from "../../../utils/constants";
import { CommunityTagModel } from "../models/CommunityTagModel"

type Props = {
    options: CommunityTagModel[];
    onSelect: (option: CommunityTagModel) => void;
    lastButton?: { label: string };
    onAddOption?: () => void;
}

export const CommunityOptionList = ({ options, onSelect, lastButton, onAddOption }: Props) => {

    return (
        <div className="community-tag-options">
            {options.length > 0 && (
                <>
                    {options.map((o, i) => (
                        <button
                            type="button"
                            key={i} 
                            onPointerDown={() => onSelect(o)}
                            onMouseDown={() => onSelect(o)}
                        >
                            {o.imageUrl && (
                                <img src={toAbsoluteUrl(o.imageUrl) } onError={(e) => { e.currentTarget.src = defaultProfileImage }} />
                            )}

                            {o.label}
                        </button>
                    ))}
                </>
            )}
            {lastButton && (
                <button type="button" className="add-option" onClick={onAddOption}>
                    {lastButton.label}
                </button>
            )}
        </div>
    )
}